export enum CardFlags {
  AMEX = 'AMEX',
  CABAL = 'CABAL',
  ELO = 'ELO',
  HIPERCARD = 'HIPERCARD',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
}
